import React from 'react';
import { WA_NUMBER } from '../data/products';
export function Footer() {
  return <footer className="bg-[#080808] border-t border-[#1a1a1a] py-10 px-5 text-center" data-id="element-128" data-mp="3gezdb400vr15">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center" data-id="element-129" data-mp="32nul2myzi10u">
        <div className="mb-2.5" data-id="element-130" data-mp="32pp3nums9h1r">
          <img src="https://cdn.magicpatterns.com/uploads/o9QuWRFj9QDHop4MmMKe7L/Logo_-_Editado.png" alt="AlphaFit" className="h-12 object-contain mx-auto" onError={e => {
          e.currentTarget.style.display = 'none';
          e.currentTarget.nextElementSibling?.classList.remove('hidden');
        }} data-id="element-131" data-mp="36p6d0z5byyc7" />
          <div className="hidden text-[1.6rem] font-black text-alphaGold tracking-[3px] uppercase" data-id="element-132" data-mp="3lgoocjn8w4p8">
            Alpha<span className="text-white" data-id="element-133" data-mp="29z6tk9nn6feu">Fit</span>
          </div>
        </div>

        <p className="text-[#555] text-[0.85rem] leading-[1.7] mb-5" data-id="element-134" data-mp="2a19u3nmf7qxt">
          Suplementos en Montevideo, Uruguay.
          <br data-id="element-135" data-mp="2evxbz3mx5n3f" />
          Malvín, Montevideo · Lunes a Sábados 10:00–18:00 · Domingos cerrado
        </p>

        <div className="flex gap-6 justify-center flex-wrap mb-5" data-id="element-136" data-mp="3gah13thslj5u">
          <a href="#productos" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-137" data-mp="3gca5f24xnrao">
            Productos
          </a>
          <a href="#nosotros" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-138" data-mp="3qapz9cvchenv">
            Nosotros
          </a>
          <a href="#faq" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-139" data-mp="31umvaqetzm7">
            FAQ
          </a>
          <a href="#envios" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-140" data-mp="cvtng5au5bc1">
            Envíos
          </a>
          <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-141" data-mp="mptrs4yamcjp">
            WhatsApp
          </a>
        </div>

        <p className="text-[#333] text-[0.8rem]" data-id="element-142" data-mp="13rg0wvkki011">
          © {new Date().getFullYear()} AlphaFit · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}